module.exports = __webpack_public_path__ + "img/message-middle-top.df98d5db.svg";